// やっていること:
//   1. 「現在に至る」チェック時に「終了年月」入力を隠して値クリア（required も外す）
//   2. 「現在の就業状況」が working / resigning のときだけ、新規職務経歴セクションを「必須」表示にする（応募画面のみ）
//   3. 「これが最新の職務経歴」チェック時に新規セクション全体を非表示にして required 解除（応募画面のみ）
//   4. 「主な職務内容」テキストエリアの残り文字数を表示

(function () {
  const state = {
    newSection: null,         // 新規職務経歴セクション全体（必須切替の対象）
    isLatestEl: null,         // 「これが最新の職務経歴」チェックボックス
    newRequiredMarks: null    // 新規セクション内の「※必須」マーク要素群
  };

  function init() {
    // 全画面共通の処理を先に紐付ける（新規セクションが無い応募同時登録画面でも動作する）
    bindCurrentlyEmployed();
    bindCharCount();

    // 新規セクションが無い画面はここで早期 return
    state.newSection = document.querySelector('[data-role="new-career-section"]');
    if (!state.newSection) return;

    // 応募画面のみで使う要素を取得し、変更イベントで updateNewCareerState を呼んで再評価する
    state.isLatestEl = document.querySelector('[data-role="is-latest-existing-career"]');
    state.newRequiredMarks = state.newSection.querySelectorAll('.entry-form__required');

    const empStatusRadios = document.querySelectorAll('input[type="radio"][data-role="employment-status"]');
    empStatusRadios.forEach(function (r) { r.addEventListener('change', updateNewCareerState); });
    if (state.isLatestEl) state.isLatestEl.addEventListener('change', updateNewCareerState);

    // 初期表示の同期（リロード後にチェック状態が残っていてもUIを合わせる）
    updateNewCareerState();
  }

  // 新規セクション内の入力欄の required 属性と「※必須」マークの表示を一括切替する。
  // data-always-optional="true" の要素（例: 「現在に至る」チェックボックス）は常に任意扱いで除外する。
  function setNewCareerRequired(required) {
    const fields = state.newSection.querySelectorAll('input[type="month"], input[type="text"], select, textarea');
    fields.forEach(function (el) {
      if (el.dataset.alwaysOptional === 'true') return;
      if (required) {
        el.setAttribute('required', 'required');
      } else {
        el.removeAttribute('required');
      }
    });
    state.newRequiredMarks.forEach(function (m) { m.style.display = required ? '' : 'none'; });
  }

  // 「現在の就業状況」の現在値（チェック中のラジオの value）を返す。未選択なら空文字列。
  function currentEmploymentStatus() {
    const checked = document.querySelector('input[type="radio"][data-role="employment-status"]:checked');
    return checked ? checked.value : '';
  }

  // 「最新の職務経歴」チェック状態と「就業状況」から、新規セクションの表示・必須状態を決定する。
  function updateNewCareerState() {
    if (!state.newSection) return;

    // チェック ON → 新規セクションは「保存しない」扱いなので隠す。required も外して送信ブロックを防ぐ。
    if (state.isLatestEl && state.isLatestEl.checked) {
      state.newSection.style.display = 'none';
      setNewCareerRequired(false);
      return;
    }

    // チェック OFF → セクション表示。
    // 就業状況が working / resigning のときだけ必須、それ以外は任意（入力があれば保存される）。
    state.newSection.style.display = '';
    const status = currentEmploymentStatus();
    const isRequired = (status === 'working' || status === 'resigning');
    setNewCareerRequired(isRequired);
  }

  // 「現在に至る」チェックの挙動を、職務経歴カード単位で紐付ける（既存カードと新規カードを独立に扱う）。
  function bindCurrentlyEmployed() {
    document.querySelectorAll('[data-role="currently-employed-checkbox"]').forEach(function (cb) {
      // 同じカード内の「終了年月」入力と「〜」記号だけを操作対象にする
      const scope = cb.closest('.entry-form__career-card, .form-wrapper, form') || document;
      const endedInput = scope.querySelector('input[type="month"][data-role="ended-at"]');
      const tildeSpan = scope.querySelector('.entry-form__period-tilde');
      function refresh() {
        if (cb.checked) {
          if (endedInput) {
            endedInput.style.display = 'none';
            endedInput.value = '';
            endedInput.removeAttribute('required');
          }
          if (tildeSpan) tildeSpan.style.display = 'none';
        } else {
          if (endedInput) endedInput.style.display = '';
          if (tildeSpan) tildeSpan.style.display = '';
        }
      }
      cb.addEventListener('change', refresh);
      refresh();
    });
  }

  // 「主な職務内容」テキストエリアの残り文字数をリアルタイム表示する。data-max で上限を指定（未指定なら2000）。
  function bindCharCount() {
    document.querySelectorAll('[data-role="textarea-counted"]').forEach(function (ta) {
      const max = parseInt(ta.getAttribute('data-max') || '2000', 10);
      const scope = ta.closest('.entry-form__career-card, .form-wrapper, form') || document;
      const remEl = scope.querySelector('[data-role="char-remaining"]');
      function refresh() {
        const len = (ta.value || '').length;
        if (remEl) remEl.textContent = Math.max(0, max - len);
      }
      ta.addEventListener('input', refresh);
      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ブラウザの「戻る」で復元されたとき (BFCache / 通常リロード両方) に、チェック状態と画面表示を再同期する
  window.addEventListener('pageshow', function () {
    if (state.newSection) updateNewCareerState();
    document.querySelectorAll('[data-role="currently-employed-checkbox"]').forEach(function (cb) {
      cb.dispatchEvent(new Event('change'));
    });
  });
})();
